import React from 'react';
import DataMetrics from '../dataMetrics';
import { FiMapPin } from 'react-icons/fi';

const Address = ({ address }) => {
  return (
    <DataMetrics classes={'padding'}>
      <span> <FiMapPin /> {address} </span>
    </DataMetrics>
  )
}
export default Address;